import React from "react";

const SitemapConcorrentes = () => {
  return (
    <section>
    
      <iframe src="https://app.powerbi.com/view?r=eyJrIjoiYjExMjhiYzgtOTg4Yy00YWQxLWIyYmItOTdhYjZkNTgxMDlmIiwidCI6ImYyMzQ4MWYzLTI2ZGItNGZjOC1hNzliLTFiZTk2ZWZjMzg4YyIsImMiOjR9" frameborder="0" allowFullScreen="true"></iframe>
    </section>
  );
};

export default SitemapConcorrentes;
